module.exports = "<div class=\"search-popup-container\" *ngIf=\"!isLoading\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-12\">\r\n      <lfwms-search-filter [searchService]=\"searchService\">\r\n      </lfwms-search-filter>\r\n    </div>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/search-filter-popup/search-filter-popup.component.html
// module id = ../../../../../src/app/shared/lookup/search-filter-popup/search-filter-popup.component.html
// module chunks = main